<template>
  <Popup
      @close="closePopup"
      round
      get-container="body"
      closeable
      v-model="showPopup"
      position="bottom" :style="{ maxHeight: '80vh' }">
    <div
        style="width: 100%;padding: 12px;display: flex;flex-direction: column;max-height: 80vh"
    >
      <h3 style="text-align: center;margin: 6px;color: #222">
        {{ form.guideTitle }}
      </h3>
      <div style="font-size: 12px;text-align: center;color:#969fa9;">
        {{ form.guideText }}
      </div>
      <CellGroup :border="false" style="flex: 1;overflow-y: auto;margin: 10px 0 20px">
        <template v-for="f in form.dataJson">
          <Field
              v-if="f.type == 'Input'"
              :required="f.required"
              v-model="f.value"
              :label="f.label"
              :placeholder="f.placeholder"
          />
          <Field
              type="textarea"
              show-word-limit
              :maxlength="120"
              v-if="f.type == 'Textarea'"
              :required="f.required"
              v-model="f.value"
              :label="f.label"
              :placeholder="f.placeholder"
          />
          <Cell v-if="f.type == 'Radio'" :required="f.required" :title="f.label" >
            <div style="display: flex;justify-content: flex-end">
              <RadioGroup v-model="f.value" direction="horizontal">
                <Radio checked-color="#FF6666" :key="i" v-for="(o, i) in f.options" :name="o">{{ o }}</Radio>
              </RadioGroup>
            </div>
          </Cell>
<!--          <div v-if="f.type == 'Radio'" class="van-cell">-->
<!--            <div style="color: #646566;font-size: 14px;padding: 8px 0">-->
<!--              <span style="color: #ee0a24" v-if="f.required">*</span>-->
<!--              {{ f.label }}-->
<!--            </div>-->
<!--            &lt;!&ndash;              direction="horizontal"&ndash;&gt;-->
<!--            <div style="padding: 10px">-->
<!--              <RadioGroup v-model="f.value">-->
<!--                <Radio :key="i" v-for="(o, i) in f.options" :name="o">{{-->
<!--                    o-->
<!--                  }}</Radio>-->
<!--              </RadioGroup>-->
<!--            </div>-->
<!--          </div>-->
          <SelectInput
              v-if="f.type == 'Select'"
              v-model="f.value"
              :title="f.label"
              :required="f.required"
              :multiple="f.multiple"
              :placeholder="f.placeholder"
              :options="f.options"
          />
          <SelectDate
              v-if="f.type == 'Date'"
              :title="f.label"
              :required="f.required"
              v-model="f.value"
              :placeholder="f.placeholder"
          />
        </template>
      </CellGroup>
      <div style="padding: 0 10px">
        <Button style="background: #F3C458;border-color:#F3C458;color: #3d3d3d;" block round  @click="submit()">确定</Button>
      </div>
    </div>
  </Popup>
</template>

<script>
import {Icon, Popup, Button, Field, RadioGroup, Radio, Toast, CellGroup, Cell} from "vant";
import { fillerLeft } from "@/utils/index.js";
import SelectDate from "./SelectDate.vue";
import SelectInput from "./SelectInput.vue";
import {addCollectionInfo} from "@/api/collect";
import {isClient} from "@/utils/isTerminal";
import {dataBuryingPoint} from "@/utils/JSBridge";
import {hsjH5BurialPoint} from "@/utils/shareCommon";
// import {
//   getTemplateByCourseId,
//   addCollectionInfo
// } from "@/api/coupon/settlement";
export default {
  name: "InfoCollection",
  props: { value: Boolean },
  data: function() {
    return {
      showPopup: false,
      params:{},
      data:null,
      form: {
        templateId:"",
        title: "",
        guideTitle: "",
        guideText: "",
        dataJson: "",
      }
    };
  },
  methods: {
    Show(params,formInfo){
      this.params = params;
      this.data = formInfo
      fillerLeft(this.form, formInfo);
      this.form.dataJson = JSON.parse(formInfo.dataJson) || [];
      this.form.dataJson.forEach((v, i) => {
        this.$set(this.form.dataJson[i], "value", "");
      });
      this.form.templateId = formInfo.id
      this.showPopup = true;
      if(isClient){
        dataBuryingPoint("B000005", "240527YYBD-003", this.params)
      }else {
        hsjH5BurialPoint("B000005", "240527YYBD-003", this.params)
      }
    },
    submit() {
      if(isClient){
        dataBuryingPoint("B000005", "240527YYBD-002", this.params)
      }else {
        hsjH5BurialPoint("B000005", "240527YYBD-002", this.params)
      }

      for (let i = 0; i < this.form.dataJson.length; i++) {
        let v = this.form.dataJson[i];
        if (v.required && !v.value) {
          Toast("带*的必须填写才能提交");
          return;
        }
      }
      addCollectionInfo({
        ...this.data,
        ...this.form,
        dataJson: JSON.stringify(this.form.dataJson)
      }).then(id => {
        Toast("保存成功！");
        this.$emit("submitOk",this.params, id);
      });

      this.showPopup = false;
    },
    closePopup(){
      if(isClient){
        dataBuryingPoint("B000005", "240527YYBD-001", this.params)
      }else {
        hsjH5BurialPoint("B000005", "240527YYBD-001", this.params)
      }
    }
  },
  created() {
    let { courseId } = window.PAGE_PARAMS;
    // getTemplateByCourseId({ id: courseId })
    //   .then(r => {
    //     if (!r) {
    //       return;
    //     }
    //     fillerLeft(this.form, r);
    //     this.form.dataJson = JSON.parse(r.dataJson) || [];
    //     this.form.dataJson.forEach((v, i) => {
    //       if (v.required) {
    //         this.hasRequire = true;
    //         this.$emit("input", true);
    //       }
    //       this.$set(this.form.dataJson[i], "value", "");
    //     });
    //     this.hasInfoCollection = true;
    //   })
    //   .catch(() => {});
  },
  components: {
    Cell,
    Icon,
    Popup,
    Button,
    Field,
    RadioGroup,
    Radio,
    SelectInput,
    SelectDate,CellGroup
  }
};
</script>
<style lang="scss" scoped>
.divider {
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  color: #49495e;
  padding: 0 15px;
}

.info-collection {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background-color: #fff;
  border-bottom: 1px solid #e3e5e9;
}
</style>
